<div class="wrapper-auth-pages">
  <div class="wrapper-auth-left add-details">
    <div class="wrapper-login-page">
      <div class="login-page">
        <div class="wrapper-logo-auth">
          <img src="../assets/icons/logo-horizontal-yellow.svg" alt="">
        </div>
        <div class="info-auth-login">
          <h1>{{'NEW_TEXT.add_details' | translate}}</h1>
          <h6>{{'NEW_TEXT.signup_for_a_new_account_by_adding_your_information_below' | translate}}</h6>
        </div>
        <form [formGroup]="completeRegistrationForm" (ngSubmit)="onSubmitCompleteRegistrationForm()" class="wrapper-content-auth">
          <!--     Name     -->
          <div class="wrapper-input" [ngClass]="{'error': completeRegistrationForm.controls['username'] | formControlErrorMessages: null : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.username' | translate}}</span>
            <div class="custom-input">
              <input type="text" (input)="onSearch()" formControlName="username" placeholder="{{'NEW_TEXT.enter_your_username' | translate}}">
            </div>
            <div *ngIf="completeRegistrationForm.controls['username'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{completeRegistrationForm.controls['username'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
            <div *ngIf="taken"
                 class="wrapper-error-message-icon">
              <img src="../../../../assets/icons/icon-error.svg" alt="">
              <span>{{'CREATE_ACCOUNT.this_username_is_already_taken' | translate}}</span>
            </div>

            <div *ngIf="taken && available.length" class="wrapper-error-message-available">
              <span>{{'CREATE_ACCOUNT.here_are_a_few_available_alternatives_you_can_use' | translate}}:</span>
              <span *ngFor="let name of available">&#64;{{ name }}</span>
            </div>

            <div class="wrapper-notice">
              <img src="../../../../assets/images/onboarding/info.svg" alt="">
              <p>{{'CREATE_ACCOUNT.this_will_be_your_unique_identity' | translate}}</p>
            </div>
          </div>
          <!--     Country     -->
          <div class="wrapper-input" [ngClass]="{'error': completeRegistrationForm.controls['country'] | formControlErrorMessages: null: formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.country' | translate}}</span>
            <div *ngIf="!selectedCountry" class="custom-input">
              <input #countrySearch  type="text" (focus)="showCountryDropdown = true" (blur)="onBlurSearchbar()" [(ngModel)]="searchQuery" (ngModelChange)="onSearchCountries()" [ngModelOptions]="{standalone: true}" placeholder="Enter country">
            </div>
            <div class="wrapper-selected-country" *ngIf="selectedCountry" (click)="removeSelectedCountry()">
              <img [src]="'../../../assets/icons/flags/' + selectedCountry.code.toLowerCase() + '.png'" alt="">
              <span>{{selectedCountry.name}}</span>
            </div>
            <div
              *ngIf="completeRegistrationForm.controls['country'] | formControlErrorMessages: null: formTriedToSubmit"
              class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{completeRegistrationForm.controls['country'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
            <div  *ngIf="showCountryDropdown" class="wrapper-list-country">
              <div class="item-country" *ngFor="let country of filteredCountries" (click)="onSelectCountry(country)">
                <img [src]="'../../../assets/icons/flags/' + country.code.toLowerCase() + '.png'" alt="">
                <span>{{country.name}}</span>
              </div>
            </div>
          </div>

          <div *ngIf="showPhoneField" class="wrapper-input" [ngClass]="{'error': completeRegistrationForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.phone_number' | translate}}</span>
            <div class="wrapper-phone-number open" [ngClass]="{'open': isAreaCodeOpen}">
              <div #areaCodeBtn class="wrapper-flags" (click)="isAreaCodeOpen = !isAreaCodeOpen">
                <img class="icon-flag" [src]="'../../../../assets/icons/flags/' + selectedArea.code.toLowerCase() + '.png'" alt="">
                <img class="icon-arrow-flags" src="../../../assets/icons/icon-arrow-left.svg" alt="">
              </div>
              <div class="wrapper-number-country">
                <span>{{selectedArea.phone_code}}</span>
              </div>
              <input type="text" formControlName="phone_number">
              <div class="content-dropdown-phone-number" *ngIf="isAreaCodeOpen">
                <div class="item-dropdown-phone-number" *ngFor="let country of Countries" (click)="onSelectCodeArea(country)">
                  <img [src]="'../../../../assets/icons/flags/' + country.code.toLowerCase() + '.png'" alt="">
                  <span>{{country.name}} ({{country.phone_code}})</span>
                </div>
              </div>
            </div>
            <div *ngIf="completeRegistrationForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.' : formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{completeRegistrationForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}}</span>
            </div>
          </div>

          <div class="wrapper-custom-checkbox" *ngIf="showPhoneField">
            <input formControlName="tos" type="checkbox" id="custom-checkbox">
            <label for="custom-checkbox">
              <span class="custom-checkbox-wrapper-check"></span>
              {{'NEW_TEXT.i_agree_to_the' | translate}} <span>{{'NEW_TEXT.terms_of_service' | translate}} </span>{{'NEW_TEXT.and' | translate}} <span>{{'NEW_TEXT.privacy_policy' | translate}}.</span>
            </label>
          </div>

          <button type="submit" [disabled]="completeRegistrationForm.invalid" class="custom-btn custom-btn--primary">
            <span>{{'NEW_TEXT.create_account' | translate}}</span>
            <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
          </button>
        </form>
      </div>
    </div>
  </div>
  <tl-onboarding-swipe class="wrapper-auth-right"></tl-onboarding-swipe>
</div>
